import Collapsible from './collapsible';
import styles from './styles.module.css';

function FaqBlock() {
    const faq = [
        {
            heading: "What's the mint cost?",
            body: "1 SOL for every item. Hurry up, it would cost way more soon!"
        },
        {
            heading: "Where I can find the proofs?",
            body: "Check out our social media accounts"
        }
    ]
    return (
      <div id="faq" className={styles.wrapper}>
          <div className={styles.container}>
              <div className={styles.headingBlock}>
                  <span className={styles.subheading}>ANY QUESTIONS?</span>
                  <h1 className={styles.heading}>FAQ</h1>
                  <p className={styles.headingParagraph}>If you have any additional questions contact us drzs@gmail.com</p>
              </div>
              {faq.map(faqItem => <Collapsible heading={faqItem.heading} body={faqItem.body} />)}
          </div>
      </div>
    );
  }

export default FaqBlock;
